/* eslint-disable */
var maxAdTitleLength = 25, maxAdDescriptionLength = 71, maxTextDisplayUrlLength = 35, maxUrlLength = 1024, maxAppStoreIdLength = 1024, maxEditorialAppealJustificationLength = 1000;
export default {
  maxAdTitleLength: maxAdTitleLength,
  maxAdDescriptionLength: maxAdDescriptionLength,
  maxTextDisplayUrlLength: maxTextDisplayUrlLength,
  maxUrlLength: maxUrlLength,
  maxAppStoreIdLength: maxAppStoreIdLength,
  maxEditorialAppealJustificationLength: maxEditorialAppealJustificationLength
};

